import getChatQuestions from "./ChatQuestions";
import {
    setGPTDeparture,
    setGPTLeaveTime, setGPTNightCount,
    setInitialChat,
    setListingGuid, setPriceRangeValue, setStarRating,
    setTravelDate
} from "../../redux/slices/searchFilterSlice";
import { updateQuestionState } from "../../redux/slices/chatBotSlice";
import { GetSearchOnlyHotelsService } from "../../services/HotelServices";
import { toast } from "react-toastify";
import {
    setActivityIndicator,
    setChatGPTOffers,
    setIsChatGPTOffers, setMetaData,
    setMetaDataCount,
    setMetaDataCountByGuid,
    setPriceExceedOffersByGuid,
    setOffers
} from "../../redux/slices/appconfigSlice";
import moment from "moment/moment";
import "moment/locale/nl";
import {
    getAirportFullObject,
    getDesireDestinationFullObject,
    getPagerMiddlePage,
    nightDifferenceCountForFlightsDate
} from "../../helpers/common";
import Swal from "sweetalert2";
import AppConfig from "../../helpers/config";
import GeniusImage from "../../assets/images/genius-bird.png";
import { setLastSearch } from "../../redux/slices/loginconfigSlice";

export const initialQuestionState = (T, gptFilters = null) => ([
    {
        text: getChatQuestions({ T, index: 7 }),
        time: new Date(),
        clientSender: false,
        id: 'whereWantToGo',
        answer: '',
        prompt: false,
        systemQuestion: true,
        surpriseMeText: true,
    }, // 0
    {
        text: getChatQuestions({ T, index: gptFilters?.departure ? 5 : 1, from: gptFilters?.departure }),
        time: new Date(),
        clientSender: false,
        id: 'fromAirport',
        answer: '',
        prompt: !!gptFilters?.departure,
        prefilledDeparture: gptFilters?.departure || '',
        systemQuestion: true,
    }, // 1
    {
        text: getChatQuestions({ T, index: gptFilters?.travelers ? 6 : 2, travelers: gptFilters?.travelers }),
        time: new Date(),
        clientSender: false,
        id: 'travelerCount',
        answer: '',
        prompt: !!gptFilters?.travelers,
        systemQuestion: true,
    }, // 2
    {
        text: getChatQuestions({ T, index: gptFilters?.infants ? 9 : 8, infants: gptFilters?.infants }),
        time: new Date(),
        clientSender: false,
        id: 'babyTravelerCount',
        answer: '',
        prompt: !!gptFilters?.infants,
        systemQuestion: true,
    }, // 3
    {
        text: getChatQuestions({ T, index: gptFilters?.leaveTime ? 10 : 3, leaveTime: gptFilters?.leaveTime }),
        time: new Date(),
        clientSender: false,
        id: 'whenLeave',
        answer: '',
        prompt: !!gptFilters?.leaveTime,
        datePicker: !gptFilters?.leaveTime,
        systemQuestion: true,
    }, // 4
    {
        text: getChatQuestions({ T, index: gptFilters?.nightCount ? 12 : 4, nightCount: gptFilters?.nightCount }),
        time: new Date(),
        clientSender: false,
        id: 'howManyNights',
        answer: '',
        prompt: !!gptFilters?.nightCount,
        systemQuestion: true,
    }, // 5
    {
        text: getChatQuestions({ T, index: 13 }),
        time: new Date(),
        clientSender: false,
        id: 'howMuchSpend',
        answer: '',
        priceRange: true,
        priceRangeFalse: false,
        systemQuestion: true,
    }, // 6
    {
        text: getChatQuestions({ T, index: 14 }),
        time: new Date(),
        id: 'greetAndHowTo',
        answer: '',
        systemQuestion: true,
    }, // 7
]);

export const initializeChatScreen = (GPTChat, dispatch, setChats, offers, setActiveIndices, questionState, gptFilters, T, loginConfig) => {
    if (GPTChat.length === 0) {
        dispatch(setInitialChat(true));
        // const firstMessage = {
        //     ...initialQuestionState(T)[0],
        //     time: new Date(),
        //     isSurpriseQuestion: true,
        //     prompt: true,
        // };
        const firstMessage = {
            ...initialQuestionState(T, gptFilters)[7],
            systemQuestion: true,
            time: new Date(),
        };
        setChats([firstMessage]);
    } else {
        const uniqueOffers = offers.filter(
            (offer, index, self) =>
                index ===
                self.findIndex((o) => o.guidForBooking === offer.guidForBooking)
        );
        const result = uniqueOffers.reduce((acc, offer) => {
            acc[offer.guidForBooking] = 1;
            return acc;
        }, {});
        setActiveIndices(result);
        setChats(GPTChat);
    }

    const _questions = [...questionState];
    if (gptFilters?.departure) {
        _questions[1] = {
            text: getChatQuestions({ T, index: 5, from: gptFilters?.departure }),
            time: new Date(),
            clientSender: false,
            id: "fromAirport",
            answer: "",
            prompt: true,
            prefilledDeparture: gptFilters?.departure || '',
            systemQuestion: true,
        };
    }
    if (gptFilters?.travelers) {
        _questions[2] = {
            text: getChatQuestions({ T, index: 6, travelers: gptFilters?.travelers }),
            time: new Date(),
            clientSender: false,
            id: "travelerCount",
            answer: "",
            prompt: true,
            systemQuestion: true,
        };
    }
    if (gptFilters?.infants) {
        _questions[3] = {
            text: getChatQuestions({ T, index: 9, infants: gptFilters?.infants }),
            time: new Date(),
            clientSender: false,
            id: "babyTravelerCount",
            answer: "",
            prompt: true,
            systemQuestion: true,
        };
    }
    if (gptFilters?.leaveTime) {
        // Normalize the date with the user's current locale
        const momentLocale = loginConfig?.locale?.code ? loginConfig.locale.code.split('_')[0].toLowerCase() : 'en';

        // Try parsing with current locale first, then fallback to English
        let parsedDate = moment(gptFilters.leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], momentLocale);

        if (!parsedDate.isValid()) {
            // Try parsing with English locale if current locale fails
            parsedDate = moment(gptFilters.leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], 'en');
        }

        const normalizedLeaveTime = parsedDate.isValid()
            ? parsedDate.locale(momentLocale).format("DD MMMM YYYY")
            : gptFilters.leaveTime; // Fallback to original if parsing fails

        _questions[4] = {
            text: getChatQuestions({ T, index: 10, leaveTime: normalizedLeaveTime }),
            time: new Date(),
            clientSender: false,
            id: "whenLeave",
            answer: "",
            prompt: true,
            systemQuestion: true,
        };
    }
    if (gptFilters?.nightCount) {
        _questions[5] = {
            text: getChatQuestions({ T, index: 12, nightCount: gptFilters?.nightCount }),
            time: new Date(),
            clientSender: false,
            id: "howManyNights",
            answer: "",
            prompt: true,
            systemQuestion: true,
        };
    }

    dispatch(updateQuestionState(_questions));
};

// The offer carousel renders in stages, so one scroll is not enough — the
// container grows after the cards mount. These retries chase that.
const SCROLL_RETRY_DELAYS = [150, 400, 700];

// Timers are tracked module-side and cleared before each new run: previously
// each search queued three uncancelled timeouts that kept the ref (and the
// closure around it) alive after the chat unmounted.
let scrollRetryTimers = [];

export const clearChatScrollRetries = () => {
    scrollRetryTimers.forEach(clearTimeout);
    scrollRetryTimers = [];
};

export const scrollChatToBottom = (chatContainerRef) => {
    clearChatScrollRetries();

    const toBottom = () => {
        if (chatContainerRef?.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    };

    toBottom();
    scrollRetryTimers = SCROLL_RETRY_DELAYS.map((delay) => setTimeout(toBottom, delay));
};

export const isOffersMessage = (item) =>
    !item?.clientSender &&
    item?.messageData?.searchGUID &&
    item?.messageData?.metaData;

export const queryStringToObject = (queryString) => {
    // Callers pass optionally-chained values (e.g. item?.messageData?.metaData),
    // so a missing or non-string metaData is reachable whenever a response is
    // malformed. Return an empty object rather than throwing into the caller.
    if (typeof queryString !== "string" || !queryString) {
        return {};
    }

    // Split the query string into key-value pairs
    let pairs = queryString.split("&");

    // Create an object to store the key-value pairs
    let result = {};

    // Iterate through each key-value pair
    for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i].split("=");
        let key = decodeURIComponent(pair[0]);
        let value = decodeURIComponent(pair[1]);

        // Store the key-value pair in the object
        result[key] = value;
    }

    return result;
}

// Same caps the Travelers quick filter enforces.
export const MAX_TRAVELERS = 6;
export const MAX_TRAVELER_ROOMS = 3;

// Passenger counts arrive in metaData either unindexed (`ADT`, `CHD`, `INF`) for
// single-room searches, or room-indexed (`ADT1`, `CHD1`, `ADT2`, ...) once
// multiple rooms are requested.
const PASSENGER_KEY_PATTERN = /^(ADT|CHD|INF)(\d*)$/;

const roomTravelersCount = (room) => room.adult + room.child + room.infants;

/**
 * Reads the passenger counts out of a chat metaData query string (or an already
 * parsed metaData object) and returns them grouped per room, in room order,
 * capped to MAX_TRAVELER_ROOMS / MAX_TRAVELERS, alongside the totals.
 *
 * Every consumer of these counts — the hotel search, the travelers state and the
 * follow-up flight requests built from it — must go through here, so they can
 * never disagree about who is travelling.
 */
export const parsePassengersFromMetaData = (metaData) => {
    const metaDataObj =
        typeof metaData === "string" ? queryStringToObject(metaData) : metaData || {};

    const roomsByNumber = new Map();

    Object.keys(metaDataObj).forEach((key) => {
        const match = PASSENGER_KEY_PATTERN.exec(key.trim());
        if (!match) return;

        const [, category, roomIndex] = match;
        // parseInt also copes with values carrying a trailing "|..." section.
        const count = parseInt(metaDataObj[key]) || 0;
        if (!count) return;

        // Unindexed keys belong to the only room of a single-room search.
        const roomNumber = roomIndex ? parseInt(roomIndex) : 1;
        const room = roomsByNumber.get(roomNumber) || {
            room: roomNumber,
            adult: 0,
            child: 0,
            infants: 0,
        };

        if (category === "ADT") room.adult += count;
        if (category === "CHD") room.child += count;
        if (category === "INF") room.infants += count;

        roomsByNumber.set(roomNumber, room);
    });

    let travelersTotal = 0;
    const rooms = [...roomsByNumber.values()]
        .sort((a, b) => a.room - b.room)
        .slice(0, MAX_TRAVELER_ROOMS)
        .filter((room) => {
            if (travelersTotal + roomTravelersCount(room) > MAX_TRAVELERS) return false;
            travelersTotal += roomTravelersCount(room);
            return true;
        });

    return {
        rooms,
        adults: rooms.reduce((n, r) => n + r.adult, 0),
        children: rooms.reduce((n, r) => n + r.child, 0),
        infants: rooms.reduce((n, r) => n + r.infants, 0),
    };
};

export const getMessageQuery = (T, gptFilters, questions, inputText, price, currency) => {
    // A missing question id used to throw out of here mid-render; an empty
    // answer degrades the prompt instead of breaking the chat.
    const getValue = (id) => (questions ?? []).find((q) => q.id === id)?.answer ?? "";
    if (gptFilters?.initialChat) {
        return T("Chat:Chat_Bot_Query_Input_For_Api", {
            travelers: getValue("travelerCount"),
            infants: getValue("babyTravelerCount"),
            to:
                inputText &&
                    getValue("whereWantToGo") === T("Chat:Chat_Bot_Surprise_Me_Api")
                    ? T("Chat:Chat_Bot_Surprise_Me_Input")
                    : getValue("whereWantToGo"),
            leaveTime: getValue("whenLeave"),
            nightsCount: getValue("howManyNights"),
            from: getValue("fromAirport"),
            low: `${currency}${price?.low}`,
            high: `${currency}${price?.high}`,
        });
    } else {
        return "";
    }
};

export const getOffers = (
    itemMessage,
    exploreMore,
    appConfig,
    loginConfig,
    price,
    setIsSent,
    dispatch,
    setActiveIndices,
    T,
    setOffersFetched,
    activeIndices,
    chatContainerRef,
    onOffersReady,
    setPriceHandler,
    handleNoCaseWithMethodForFlight,
    chatGPTPrice,
    handlePriceUpdateChatWizard,
    removeChatMessageBySearchGUID
) => {
    try {
        // Inside the try: anything that parses the incoming message can fail on
        // a malformed response, and the caller does not catch.
        const metaDataObj = queryStringToObject(itemMessage?.messageData?.metaData);

        let searchParams = {
            transaction_id: appConfig?.transaction_id,
            GUID: itemMessage?.messageData?.searchGUID,
            Locale: loginConfig?.locale?.code,
            Page: 0,
            currency: loginConfig?.currency?.code,
            SearchType: "GPT",
            FilterPrePost: {
                minPrice: Number(price?.low),
                maxPrice: Number(price?.high),
            },
        };

        if (chatGPTPrice?.low >= 0 && chatGPTPrice?.high) {
            searchParams.FilterPrePost.minPrice = Number(chatGPTPrice.low);
            searchParams.FilterPrePost.maxPrice = Number(chatGPTPrice.high);
        }

        let PassengerAgeRoomItemList = [];
        // Rooms are numbered sequentially in the request, independent of the
        // index used by the metaData keys.
        parsePassengersFromMetaData(metaDataObj).rooms.forEach((room, index) => {
            const roomCounter = index + 1;
            for (let i = 0; i < room.infants; i++) {
                PassengerAgeRoomItemList.push({
                    PassengerCategory: "Infant",
                    Room: roomCounter,
                });
            }
            for (let i = 0; i < room.adult; i++) {
                PassengerAgeRoomItemList.push({
                    PassengerCategory: "Adult",
                    Room: roomCounter,
                });
            }
            for (let i = 0; i < room.child; i++) {
                PassengerAgeRoomItemList.push({
                    PassengerCategory: "Child",
                    Room: roomCounter,
                });
            }
        });

        let FlightSegmentList = [];

        let inbound_params = {};
        let outbound_params = {};
        inbound_params.Departure = {
            CodeList: [metaDataObj?.Dep],
            Date: metaDataObj?.DepDate,
        };

        inbound_params.Arrival = {
            CodeList: [
                metaDataObj?.Dest === "XXX" || metaDataObj?.Dest === "Anywhere"
                    ? "[ALL][000001][Anywhere]"
                    : metaDataObj?.Dest,
            ],
        };

        outbound_params.Departure = {
            CodeList: [
                metaDataObj?.Dest === "XXX" || metaDataObj?.Dest === "Anywhere"
                    ? "[ALL][000001][Anywhere]"
                    : metaDataObj?.Dest,
            ],
            Date: metaDataObj?.RetDate,
        };

        outbound_params.Arrival = {
            IataCodeList: [metaDataObj?.Dep],
        };

        FlightSegmentList.push(inbound_params);
        FlightSegmentList.push(outbound_params);

        if (FlightSegmentList.length > 0) {
            searchParams.FlightSegmentList = FlightSegmentList;
        }

        if (PassengerAgeRoomItemList.length > 0) {
            searchParams.PassengerAgeRoomItemList = PassengerAgeRoomItemList;
        }

        const executeSearch = async (params) => {
            try {
                const response = await GetSearchOnlyHotelsService(params);
                let preventRemoveChatMessage = false;
                // GetSearchOnlyHotelsService resolves three different shapes:
                //   normal    -> { correlationId, hotelsArray, response }
                //   RealTime  -> { correlationId, hotelsArray }
                //   warning code outside 204.02/204.03/204.05 -> the RAW axios
                //               response, which has no hotelsArray and carries
                //               its warnings one level higher.
                // Normalised here so the cleanup below sees warnings on every
                // shape. The modal checks further down deliberately keep reading
                // `response.response` — they only ever apply to the wrapper.
                const responseWarnings =
                    response?.response?.data?.warnings ?? response?.data?.warnings;
                setIsSent(true);
                // setInputPlaceholderText(T("Chat:Chat_Bot_Input_Placeholder"));
                dispatch(setInitialChat(false));

                if (response?.hotelsArray?.length && onOffersReady) {
                    onOffersReady(itemMessage?.time);
                }

                if (response?.response) {
                    if (
                        response?.response?.data?.warnings?.length &&
                        response?.response?.data?.warnings[0]?.code === "204.02"
                    ) {
                        const result = await Swal.fire({
                            title: T("Common:No_Matches_Under_Budget"),
                            // text: T("Common:No_Matches_Under_Budget_Description"), // 'We couldn’t find any direct flights. Would you like to see results with a stopover?',
                            text: response?.response?.data?.warnings[0]?.description || T("Common:No_Matches_Under_Budget_Description"), // 'We couldn’t find any direct flights. Would you like to see results with a stopover?',
                            iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                            showCancelButton: true,
                            confirmButtonText: T("Buttons:Button_Yes"),
                            cancelButtonText: T("Buttons:Button_No"),
                            confirmButtonColor: "#05CE78",
                            cancelButtonColor: "#596C7F",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        // IF USER CLICKS YES → retry with full app price range
                        if (result.isConfirmed) {
                            const retryParams = {
                                ...params,
                                FilterPrePost: {
                                    minPrice: AppConfig.minPrice,
                                    maxPrice: AppConfig.maxPrice,
                                },
                                SearchType: "Popup",
                            };
                            dispatch(setPriceRangeValue({ low: AppConfig.minPrice, high: AppConfig.maxPrice }));
                            setPriceHandler({ low: AppConfig.minPrice, high: AppConfig.maxPrice });
                            dispatch(
                                setPriceExceedOffersByGuid({
                                    guid: itemMessage?.messageData?.searchGUID,
                                    status: true,
                                })
                            );
                            setIsSent(false);
                            // setInputPlaceholderText(T("Chat:Chat_Bot_Waiting_Placeholder_Text"));
                            return executeSearch(retryParams);
                        } else {
                            // setInputPlaceholderText(T("Chat:Chat_Bot_Price_Exceed_Placeholder"));
                            // Mirror the 204.05 decline path below and stop here.
                            // Falling through would keep applying this declined
                            // search's offers, travel dates and price range.
                            if (typeof removeChatMessageBySearchGUID === "function") {
                                removeChatMessageBySearchGUID(itemMessage?.messageData?.searchGUID);
                            }
                            if (typeof handleNoCaseWithMethodForFlight === "function") {
                                handleNoCaseWithMethodForFlight(T("Chat:Chat_Bot_Price_Exceed_Placeholder"));
                            }
                            return;
                        }
                    }

                    if (
                        response?.response?.data?.warnings?.length &&
                        response?.response?.data?.warnings[0]?.code === "204.05"
                    ) {
                        // toast.info(response?.response?.data?.warnings[0].description);
                        const result = await Swal.fire({
                            title: T("Common:Flights_Info"),
                            text: T("Common:Continue_With_Direct_Flights"), // 'We couldn’t find any direct flights. Would you like to see results with a stopover?',
                            iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                            showCancelButton: true,
                            confirmButtonText: T("Buttons:Button_Yes"),
                            cancelButtonText: T("Buttons:Button_No"),
                            confirmButtonColor: "#05CE78",
                            cancelButtonColor: "#596C7F",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        // IF USER CLICKS NO → STOP EXECUTION
                        if (!result.isConfirmed) {
                            // setInputPlaceholderText(T("Chat:Chat_Bot_Flight_Modal_Stopover_Placeholder"));
                            if (typeof removeChatMessageBySearchGUID === "function") {
                                removeChatMessageBySearchGUID(itemMessage?.messageData?.searchGUID);
                            }
                            if (typeof handleNoCaseWithMethodForFlight === "function") {
                                handleNoCaseWithMethodForFlight(T("Chat:Chat_Bot_Flight_Modal_Stopover_Placeholder"));
                            }
                            return;
                        } else {
                            // Accepting stopovers does NOT re-run the search — the
                            // same response is reused. Only keep the chat message
                            // if that response actually carries offers, otherwise
                            // it would be left visible with nothing in it.
                            preventRemoveChatMessage = response?.hotelsArray?.length > 0;
                        }
                    }

                    if (
                        response?.response?.data?.warnings?.length &&
                        response?.response?.data?.warnings[0]?.code === "204.03"
                    ) {
                        await Swal.fire({
                            title: T("Common:Offers_Not_Found"),
                            text: response?.response?.data?.warnings[0]?.description,
                            iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                            showCancelButton: false,
                            confirmButtonText: T("Buttons:Button_Ok"),
                            confirmButtonColor: "#05CE78",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                    }
                }

                // Nothing to show for this search — drop the chat message it belongs to.
                // A missing hotelsArray counts as "no offers": the raw-axios shape
                // has none at all, so `length === 0` would have read as false and
                // left the message stranded.
                const hasNoOffers = !response?.hotelsArray?.length;
                const hasWarnings = responseWarnings?.length > 0;

                if (
                    (hasNoOffers || hasWarnings) &&
                    !preventRemoveChatMessage &&
                    typeof removeChatMessageBySearchGUID === "function"
                ) {
                    removeChatMessageBySearchGUID(itemMessage?.messageData?.searchGUID);
                }

                if (exploreMore && response?.hotelsArray?.length) {
                    dispatch(setIsChatGPTOffers(true));
                    dispatch(setListingGuid(response?.correlationId));
                    dispatch(setOffers(response?.hotelsArray));
                    dispatch(setActivityIndicator(false));
                } else if (!exploreMore && response?.hotelsArray?.length) {
                    const updatedIndices = { ...activeIndices };
                    updatedIndices[itemMessage?.messageData?.searchGUID] = 1;
                    setActiveIndices(updatedIndices);
                    dispatch(setChatGPTOffers(response?.hotelsArray)); // adding offers for search
                }

                if (chatContainerRef?.current?.scrollHeight) {
                    scrollChatToBottom(chatContainerRef);
                }

                if (response?.response?.data?.metaData?.metaTravelData) {
                    const metaTravelData =
                        response?.response?.data?.metaData?.metaTravelData;


                    dispatch(setTravelDate({
                        startDate: moment(new Date(metaTravelData?.depDate)).format('ddd MMM DD YYYY'),
                        endDate: moment(new Date(metaTravelData?.retDate)).format('ddd MMM DD YYYY'),
                    }));

                    // Format the date with the user's locale
                    const momentLocale = loginConfig?.locale?.code ? loginConfig.locale.code.split('_')[0].toLowerCase() : 'en';
                    dispatch(
                        setGPTLeaveTime(
                            moment(metaTravelData?.depDate).locale(momentLocale).format("DD MMMM YYYY")
                        )
                    ); // Setting departure date from meta data in GeniusGPT

                    await getAirportFullObject({
                        text: metaTravelData?.from,
                        locale: loginConfig?.locale?.code,
                        dispatch,
                    }); // Setting departure from for GeniusGPT.

                    await getDesireDestinationFullObject({
                        text: metaTravelData?.to,
                        locale: loginConfig?.locale?.code,
                        dispatch,
                    }); // Setting desired country from metaData in app local storage.

                    dispatch(setGPTDeparture(metaTravelData?.from)); // Setting departure from for GeniusGPT.

                    let count = nightDifferenceCountForFlightsDate(
                        metaTravelData?.depDate,
                        metaTravelData?.retDate
                    );
                    dispatch(setGPTNightCount(count.toString()));

                    dispatch(
                        setStarRating({
                            min: metaDataObj?.MinStar,
                            max: metaDataObj?.MaxStar,
                        })
                    ); // Storing the Star Rating

                    dispatch(
                        setMetaDataCount(
                            response?.response?.data?.metaData?.offersAfterFilter || 0
                        )
                    );
                    dispatch(
                        setMetaDataCountByGuid({
                            guid: itemMessage?.messageData?.searchGUID,
                            count: response?.response?.data?.metaData?.offersAfterFilter || 0,
                        })
                    );


                    // `response` is the service wrapper, so the payload lives at
                    // response.response.data — reading response.data here made
                    // this dispatch undefined and wiped the value the service
                    // had already stored.
                    dispatch(setMetaData(response?.response?.data?.metaData));

                    // Update the price range in the chat wizard with respect to the search results
                    handlePriceUpdateChatWizard({
                        low: params?.FilterPrePost?.minPrice,
                        high: params?.FilterPrePost?.maxPrice <= AppConfig.maxPrice
                            ? params?.FilterPrePost?.maxPrice
                            : AppConfig.maxPrice,
                    });
                }

                if (response?.hotelsArray?.length) {
                    const lastSearchParams = {
                        ...params,
                        date: new Date(),
                        GUID: '',
                        id: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
                    };

                    dispatch(setLastSearch(lastSearchParams)); // storing last search as cache.
                }

                setOffersFetched(true);
            } catch (error) {
                setIsSent(true);
                // setInputPlaceholderText(T("Chat:Chat_Bot_Input_Placeholder"));

                // The search never produced offers, so the chat message it
                // belongs to would otherwise be left empty — same cleanup the
                // no-offers path performs.
                if (typeof removeChatMessageBySearchGUID === "function") {
                    removeChatMessageBySearchGUID(itemMessage?.messageData?.searchGUID);
                }

                if (error?.response?.data?.errors?.length) {
                    toast.error(error?.response?.data?.errors[0]?.description);
                } else if (error?.response?.status === 500) {
                    toast.error(T("Toasts:Toast_Description_Server_Error_Message"));
                }
            }
        };

        setIsSent(false);
        // setInputPlaceholderText(T("Chat:Chat_Bot_Waiting_Placeholder_Text"));

        executeSearch(searchParams);
    } catch {
        setIsSent(true);
        // setInputPlaceholderText(T("Chat:Chat_Bot_Input_Placeholder"));
    }
};

export const getCustomOffers = (item, offers, price) => {
    // Offers can be absent while a search is still in flight.
    return (offers ?? [])
        .filter((offer) => {
            const offerPrice = Number(offer?.perPersonPrice?.totalPrice);
            return offer.guidForBooking === item?.messageData?.searchGUID && offerPrice >= Number(price?.low) && offerPrice <= Number(price?.high)
        })
        .slice(0, 3);
};

export const handleNavigationToMoreOffers = async (type, dispatch, item, messageItem, loginConfig, navigate, metaDataCountByGuid, priceExceedOffersByGuid) => {
    dispatch(setActivityIndicator(true));

    const metaData = messageItem?.messageData?.metaData;
    const params = new URLSearchParams(metaData);
    const from = params.get("Dep");
    const to = params.get("Dest");

    const obj = Object.fromEntries(params.entries());


    if (obj?.DepDate && obj?.RetDate) {
        dispatch(
            setTravelDate({
                startDate: moment(new Date(obj?.DepDate)).format('ddd MMM DD YYYY'),
                endDate: moment(new Date(obj?.RetDate)).format('ddd MMM DD YYYY'),
            })
        ); // Setting dates from mete data in app local storage.
    }

    if (from) {
        await getAirportFullObject({
            text: from,
            locale: loginConfig?.locale?.code,
            dispatch,
        }); // Setting departure from for GeniusGPT.
    }

    if (to) {
        await getDesireDestinationFullObject({
            text: to,
            locale: loginConfig?.locale?.code,
            dispatch,
        }); // Setting desired country from metaData in app local storage.
    }

    dispatch(setActivityIndicator(false));

    const guid = messageItem?.messageData?.searchGUID;
    const totalCount = metaDataCountByGuid?.[guid] || 0;
    const isPriceExceedOffers = priceExceedOffersByGuid?.[guid] || false;
    const middlePage = isPriceExceedOffers ? 1 : getPagerMiddlePage(totalCount, 10) || 1;
    if (type === 'search') {
        navigate(
            "/search/" +
            guid +
            "/query?page=" +
            middlePage +
            "&locale=" +
            loginConfig.locale.code +
            "&currency=" +
            loginConfig?.currency?.code +
            "&searchType=Listing"
        );
    } else {
        navigate(`/map/${guid}/offers/chat/${middlePage}`);
    }
}

export const getMessageText = (item) => {
    if (isOffersMessage(item)) {
        const pattern = /\[PSEUDOCODE\][\s\S]*?\[\/PSEUDOCODE\]/g;
        const cleanedText = item?.text?.replace(pattern, "");
        return cleanedText;
    }
    return item?.text;
};

export const extractSearchFiltersFromHistory = (searchObject) => {
    if (!searchObject) return null;

    try {
        const flightSegments = searchObject?.FlightSegmentList || [];
        const passengerList = searchObject?.PassengerAgeRoomItemList || [];
        const filterPrePost = searchObject?.FilterPrePost || {};

        // Extract travelers (Adult count) and Children (Child count)
        // Extract travelers (Adult count) and infants (Child count).
        // Intentional: the search payload carries infants under the "Child"
        // category, so this mapping is deliberate — do not "correct" it to
        // "Infant".
        const travelers = passengerList.filter(p => p?.PassengerCategory === "Adult").length;
        const infants = passengerList.filter(p => p?.PassengerCategory === "Child").length;

        // Extract departure and arrival from first segment
        const firstSegment = flightSegments[0] || {};
        const secondSegment = flightSegments[1] || {};

        const from = firstSegment?.Departure?.CodeList?.[0] || "";
        const to = firstSegment?.Arrival?.CodeList?.[0] || firstSegment?.Arrival?.IataCodeList?.[0] || "";
        const leaveTime = firstSegment?.Departure?.Date || "";

        // Calculate nights count (difference between return and departure dates)
        const departureDate = new Date(firstSegment?.Departure?.Date);
        const returnDate = new Date(secondSegment?.Departure?.Date);
        const nightsCount = Math.floor((returnDate - departureDate) / (1000 * 60 * 60 * 24));

        return {
            travelers: travelers.toString(),
            infants: infants.toString(),
            to,
            from,
            leaveTime,
            nightsCount: nightsCount.toString(),
            low: filterPrePost?.minPrice || 0,
            high: filterPrePost?.maxPrice || 2500,
        };
    } catch (error) {
        console.error("Error extracting filters from search history:", error);
        return null;
    }
};
